import type { DemoItem } from '@/types';

export const demos: DemoItem[] = [
  {
    id: 1,
    name: 'AI聊天机器人',
    description: '使用AI聊天模型进行对话',
    tech: ['AI', 'JavaScript'],
    status: '在线演示',
    link: '/demo/chat',
  },
  {
    id: 2,
    name: '群聊功能',
    description: '使用WebSocket实现群聊功能',
    tech: ['WebSocket', 'JavaScript'],
    status: '在线演示',
    link: '/demo/group-chat',
  },
  {
    id: 3,
    name: 'VR体验',
    description: 'VR全景看房',
    tech: ['three.js'],
    status: '在线演示',
    link: '/demo/vr',
  },
  {
    id: 4,
    name: '数据可视化',
    description: '实时数据图表展示',
    tech: ['echarts', 'JavaScript'],
    status: '在线演示',
    link: '/demo/visualize',
  },
  {
    id: 9,
    name: 'Live2D看板娘',
    description: 'Live2D看板娘交互演示',
    tech: ['Live2D', 'WebGL'],
    status: '在线演示',
    link: '/demo/live2d',
  },
  {
    id: 5,
    name: '大文件上传',
    description: '支持大文件上传功能,断点续传,进度条,取消上传',
    tech: ['JavaScript'],
    status: '开发中',
    // link: '/demo/upload',
  },
  {
    id: 6,
    name: '游戏开发',
    description: '简单HTML5游戏示例',
    tech: ['Canvas', 'JavaScript'],
    status: '规划中',
  },
  {
    id: 7,
    name: 'AI应用',
    description: '机器学习模型演示',
    tech: ['TensorFlow.js', 'AI'],
    status: '规划中',
  },
  
  {
    id: 8,
    name: '物联网控制',
    description: '设备远程控制面板',
    tech: ['WebSocket', 'IoT'],
    status: '规划中',
  },
];

export const getStatusColor = (status: string): string => {
  switch (status) {
    case '在线演示':
      return '#10b981';
    case '开发中':
      return '#f59e0b';
    case '规划中':
      return '#6b7280';
    default:
      return '#6b7280';
  }
};